import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const throttle = (func, delay) => {
    let lastCall = 0;

    return (...args) => {
        const now = new Date().getTime();

        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;

        return func.apply(this, args);
    };
};

const Nav = ({ content, navIndex }) => {
    const navBoxRef = useRef(null);
    const navRef = useRef(null);
    const [isFixNav, setIsFixNav] = useState(false);
    const [activeIndex, setActiveIndex] = useState(navIndex);
    const guestNameList = content.map((item) => item.userName);
    // const guestNameList = ['同行者', '总结篇', '嘉宾1', '嘉宾2', '嘉宾3', '嘉宾4', '嘉宾5', '嘉宾6', '嘉宾7', '嘉宾8', '嘉宾9', '嘉宾10', '嘉宾11', '嘉宾12'];

    useEffect(() => {
        setActiveIndex(navIndex);
    }, [navIndex]);

    useEffect(() => {
        const windowHeight = window.innerHeight;
        const navDom = navBoxRef.current;
        const navHeight = navRef.current.clientHeight;
        const navDistanceFromWindow = (windowHeight - navHeight) / 2;
        let navFlag = false;

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 800);

        window.addEventListener('scroll', () => {
            const navTop = navDom.getBoundingClientRect().top;

            // 判断导航是否吸顶
            if (navTop <= navDistanceFromWindow && !navFlag) {
                navFlag = true;
                setIsFixNav(true);
            }
            if (navTop > navDistanceFromWindow && navFlag) {
                navFlag = false;
                setIsFixNav(false);
            }
        });
    }, []);

    const anchorHandle = (index) => {
        const anchorDom = document.getElementById(`guestBox_${index}`);
        const windowHeight = window.innerHeight;
        const anchorHeight = anchorDom.clientHeight;
        const anchorDistCenter = (windowHeight - anchorHeight) / 2;
        const anchorSectiondist = anchorDom.offsetTop;

        // setActiveIndex(index);

        window.scroll({ top: anchorSectiondist - anchorDistCenter, behavior: 'smooth' });
    };

    return (
        <div className={styles.navBox} ref={navBoxRef}>
            <div className={`${styles.nav} ${isFixNav ? styles.navFixed : ''}`} ref={navRef}>
                {guestNameList.map((item, index) => {
                    const titleLength = item.length;
                    const title = titleLength > 7 ? `${item.substring(0, 7)}...` : item;

                    return (
                        <div className={`${styles.navItem} ${activeIndex === index ? styles.active : ''}`} key={index} onClick={() => anchorHandle(index)}>
                            {title}
                        </div>
                    );
                })}
                <div className={`${styles.navItem} ${activeIndex === guestNameList.length ? styles.active : ''}`} onClick={() => anchorHandle(guestNameList.length)}>
                    往季
                </div>
            </div>
        </div>
    );
};

Nav.propTypes = {
    content: PropTypes.array,
    navIndex: PropTypes.number,
};

export default errorBoundary(Nav);
